import { useEffect, useRef } from "react";

const WORDS = ["Full-Stack", "TypeScript", "React", "DevOps", "GenAI", "Automation"];

/** Infinite marquee that skews based on scroll velocity (paused under reduce-motion). */
export function Marquee() {
  const skewRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let lastY = window.scrollY;
    let vel = 0;
    let raf = 0;

    const loop = () => {
      const skew = skewRef.current;
      if (!document.documentElement.classList.contains("reduce-motion")) {
        const dy = window.scrollY - lastY;
        lastY = window.scrollY;
        vel += (dy - vel) * 0.18;
        const s = Math.max(-10, Math.min(10, vel * 0.5));
        if (skew) skew.style.transform = `skewX(${s}deg)`;
      } else {
        lastY = window.scrollY;
        if (skew) skew.style.transform = "none";
      }
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <div className="marquee">
      <div className="marquee-skew" ref={skewRef}>
        <div className="marquee-track">
          {[...WORDS, ...WORDS].map((w, i) => (
            <span key={i}>{w}</span>
          ))}
        </div>
      </div>
    </div>
  );
}
